import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import * as pages from '../../core/routing/page-names';
import { ManualImportComponent } from './manual-import.component';
import { ImportType } from 'src/app/base/models/models.swagger.generated';
import { ConfigurationInterfaceGuard } from 'src/app/base/guards/configuration-interface.guard';


const routes: Routes = [
  {
    path: pages.manualImportPageName,
    canActivate: [ConfigurationInterfaceGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: pages.manualImportSalesOrdersPageName
      },
      {
        path: pages.manualImportSalesOrdersPageName,
        component: ManualImportComponent,
        resolve: {
          importType: ()=>{return ImportType.SalesOrder;}
        }
      },
      {
        path: pages.manualImportVendorDeliveryDatePageName,
        component: ManualImportComponent,
        resolve: {
          importType: ()=>{return ImportType.VendorDeliveryDate;}
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManualImportRoutingModule { }
